import { Card, Heading, Text } from "@/design-system";
import type { LegalHighlight } from "../content/types";
import { LegalRichText } from "./legalRichText";

type LegalHighlightsProps = {
  highlights: LegalHighlight[];
};

/** "O essencial": o documento inteiro em quatro cartões, antes do texto. */
export const LegalHighlights = ({ highlights }: LegalHighlightsProps) => (
  <section
    aria-labelledby="essencial-title"
    className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 sm:px-6 lg:px-8"
  >
    <Heading level={2} size={3} id="essencial-title">
      O essencial
    </Heading>
    <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {highlights.map(({ icon: Icon, title, text }) => (
        <li key={title}>
          <Card className="flex h-full flex-col gap-3">
            <span className="bg-ds-brand-50 text-ds-brand-700 rounded-ds-md flex size-10 items-center justify-center">
              <Icon aria-hidden="true" className="size-5" />
            </span>
            <Heading level={3} size={4}>
              {title}
            </Heading>
            <Text size="small" tone="muted">
              <LegalRichText text={text} />
            </Text>
          </Card>
        </li>
      ))}
    </ul>
  </section>
);
